import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { api } from 'AurionCR/components';

export enum RTK_TAGS {
  RATED_ENTITY_REPORT_SERIES_RATING = 'ratedEntityReportSeriesRating',
}

export const axiosBaseQuery =
  (): BaseQueryFn<AxiosRequestConfig, unknown, AxiosError | Error> =>
  async ({ method, ...rest }) => {
    try {
      const result = await api({
        ...rest,
        method: method || 'get',
      });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError as AxiosError;
      return {
        error: err,
      };
    }
  };

export const apiRtk = createApi({
  reducerPath: 'apiRtk',
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({
  }),
  tagTypes: Object.values(RTK_TAGS),
});

export const isRejectedMutation = <T>(
  mutationResult: any,
): mutationResult is { error: T } => {
  return Boolean(mutationResult && mutationResult.error);
};
export const isFulfilledMutation = <T>(
  mutationResult: any,
): mutationResult is { data: T } => {
  return Boolean(
    mutationResult &&
      Object.hasOwn(mutationResult, 'data'),
  );
};